var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Box, Button, Chip, Divider, Grid, Stack, Tooltip, Typography, } from "@mui/material";
import { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { useRetrievePlayerByUserId, useRetrieveTeamsByPlayerId, } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { EmptyState } from "../common/EmptyState";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { TeamCard } from "./TeamCard";
var TeamSection = function (_a) {
    var title = _a.title, icon = _a.icon, teams = _a.teams, tooltip = _a.tooltip;
    return (_jsxs(Box, { children: [_jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 2 }, children: [icon, _jsx(Typography, { variant: "h6", children: title }), _jsx(Chip, { label: teams.length, size: "small" }), tooltip && (_jsx(Tooltip, { title: tooltip, children: _jsx(InfoOutlinedIcon, { sx: { fontSize: "1.1rem", color: "text.secondary" } }) }))] }), _jsx(Grid, { container: true, spacing: 2, children: teams.map(function (team) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: _jsx(TeamCard, { team: team }) }, team.id)); }) })] }));
};
var Teams = function () {
    var _a = useContext(UserContext), contextUser = _a.user, isContextUserLoading = _a.loading;
    var _b = useRetrievePlayerByUserId({ userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk }), isPlayerLoading = _b.isLoading, playerError = _b.error, player = _b.data;
    var _c = useRetrieveTeamsByPlayerId({
        playerId: player === null || player === void 0 ? void 0 : player.id,
    }), isLoading = _c.isLoading, error = _c.error, teams = _c.data;
    var currentUserId = contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk;
    var _d = __read(useMemo(function () {
        var e_1, _a;
        var _b;
        if (!teams)
            return [[], [], []];
        var managed = [];
        var playerList = [];
        var other = [];
        try {
            for (var _c = __values(__spreadArray([], __read(teams), false).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            })), _d = _c.next(); !_d.done; _d = _c.next()) {
                var team = _d.value;
                if (team.manager === currentUserId) {
                    managed.push(team);
                }
                else if ((player === null || player === void 0 ? void 0 : player.id) && ((_b = team.players) === null || _b === void 0 ? void 0 : _b.includes(player.id))) {
                    playerList.push(team);
                }
                else {
                    other.push(team);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return [managed, playerList, other];
    }, [teams, currentUserId, player === null || player === void 0 ? void 0 : player.id]), 3), managerTeams = _d[0], playerTeams = _d[1], otherTeams = _d[2];
    if (isLoading || isPlayerLoading || isContextUserLoading) {
        return _jsx(Loading, {});
    }
    if (error || teams === undefined || playerError) {
        return (_jsx(ErrorView, { error: error || new Error("Failed to retrieve teams data.") }));
    }
    return (_jsxs(Box, { children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "h4", children: "Teams" }), _jsx(Button, { variant: "contained", color: "primary", size: "large", component: Link, to: "/teams/create/", children: "Create Team" })] }), _jsx(Divider, { sx: { my: 2 } }), teams.length > 0 ? (_jsxs(Stack, { spacing: 4, children: [managerTeams.length > 0 && (_jsx(TeamSection, { title: "Manager", icon: _jsx(AdminPanelSettingsOutlinedIcon, { sx: { color: "text.secondary" } }), teams: managerTeams })), playerTeams.length > 0 && (_jsx(TeamSection, { title: "Player", icon: _jsx(SportsSoccerIcon, { sx: { color: "text.secondary" } }), teams: playerTeams })), otherTeams.length > 0 && (_jsx(TeamSection, { title: "Other Teams", icon: _jsx(GroupsIcon, { sx: { color: "text.secondary" } }), teams: otherTeams, tooltip: "Teams you created but don't actively manage or play in" }))] })) : (_jsx(EmptyState, { icon: _jsx(GroupsIcon, {}), heading: "No teams yet", description: "You're not part of any teams. Create one to start managing your squad, tracking stats, and organising matches.", actionLabel: "Create Team", actionTo: "/teams/create/" }))] }));
};
export default Teams;
